import React from 'react';
import { useLocation } from 'react-router-dom';
import useMediaQuery from '../hooks/useMediaQuery';

const LoadingSpinner = () => {
  const location = useLocation();
  const isDesktopViewport = useMediaQuery('(min-width: 1024px)');
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isDesktopShellEligible = !location.pathname.startsWith('/admin')
    && !location.pathname.startsWith('/venue-portal')
    && !location.pathname.startsWith('/partners')
    && !location.pathname.startsWith('/partner');
  const isDesktopRoute = location.pathname.startsWith('/desktop') || (isDesktopViewport && isDesktopShellEligible);
  const loaderBg = isAdminRoute ? 'bg-black' : (isDesktopRoute ? 'bg-[#0d0d0d]' : 'bg-[#0f0f23]');
  
  return (
    <div className={`fixed inset-0 z-[200] flex min-h-screen w-screen items-center justify-center ${loaderBg}`}>
      <div className="text-center space-y-6">
        {/* Mascot Logo with subtle bounce animation */}
        <div className="flex justify-center">
          <div className="animate-bounce" style={{ animationDuration: '1.5s' }}>
            <picture>
              <source srcSet="/logo-mascot.webp" type="image/webp" />
              <img 
                src="/logo-mascot.png" 
                alt="STAGSTER Loading" 
                className="w-24 h-24 drop-shadow-lg"
                width="96"
                height="96"
              />
            </picture>
          </div>
        </div>
        
        {/* Animated text */}
        <div>
          <p className="text-white font-semibold text-lg tracking-wide">STAGSTER</p>
          <p className="text-white/60 text-xs mt-2">Solo? You're IN.</p>
        </div>

        {/* Loading indicator */}
        <div className="flex justify-center gap-1.5">
          <div className={`w-2 h-2 rounded-full animate-pulse ${isDesktopRoute ? 'bg-white/40' : 'bg-purple-500'}`}></div>
          <div className={`w-2 h-2 rounded-full animate-pulse ${isDesktopRoute ? 'bg-white/40' : 'bg-purple-500'}`} style={{ animationDelay: '0.2s' }}></div>
          <div className={`w-2 h-2 rounded-full animate-pulse ${isDesktopRoute ? 'bg-white/40' : 'bg-purple-500'}`} style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
